import { BaseModel } from "./base.model";

export class PostavkeDto extends BaseModel {
    id: number;
    aplikacija: number | null;
    parametar: string;
    vrijednost: string;
    pojassnjenje: string;
}